'use strict';

if (typeof document != 'undefined') require('babel-polyfill');

var _ = require('lodash');
var LinkedStateMixin = require('react-addons-linked-state-mixin');
var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
import cookies from "js-cookie"

var Router = ReactRouter.Router;
var Route = ReactRouter.Route;

import '../../../../common-js/framework/Sentry.jsx';

var Components = require('../components');
var Global = require('../global');

var Image = require('./image.jsx');
var TopLevel = require('./collection-top-level.jsx');
var CollectionListing = require('./collection-listing.jsx');

import isNode from "../is-node"
import css from "../css"

if (css) require('./collections.scss');

if (cookies.get("EXPERIMENT_PRODUCT_PAGE_WITH_FORM") === 'TRUE')
    var ProductDetail = require('./product/experiment-product-page-with-form-product-page.jsx')
else
    var ProductDetail = require('./product/product-page.jsx');

var CollectionsTemplate = React.createClass({
    mixins: [ LinkedStateMixin ],
    
    getInitialState: function() {
        return {
            // Only display the footer if the whole page can be rendered in one go (from Payload)
            // - hide the footer if the main content is about to be loaded by XHR as in a transition from Collection listing to Product Detail
            showFooter: isNode,
        };
    },
    render: function() {
        return (
            <div>
                <Components.Header tab='collection' landing='standard' />
                <div>
                    {React.cloneElement(this.props.children, {
                        showFooter: this.linkState('showFooter'),
                    })}
                    <Components.Footer placeholder={!this.state.showFooter} location={this.props.location} />
                </div>
            </div>
        );
    }
});

var collectionMap = {};
Payload.Collections.forEach(c => {
    if (c.subcats.length) {
        c.subcats.forEach(s => {
            s.parent = c;
            collectionMap[s.url] = s;
        });
    }
    collectionMap[c.url] = c;
});

var collectionRoutes = Payload.Collections.map(a => {
    var category = (
        <Route key           = {a.id}
               path          = {a.url + '(&page=:page)'}
               component     = {a.subcats.length ? TopLevel.SubCollections : CollectionListing}
               onEnter       = {Global.GAPageview}
               collectionMap = {collectionMap} />
    )
    return a.subcats.length ? category : (
        <Route key='root'>
            {category}
            {a.subcats.length
                ? (<Route> 
                    {collection.subcats.map(b => (
                        <Route key           = {b.id}
                               path          = {b.url+'(&page=:page)'}
                               component     = {CollectionListing}
                               onEnter       = {Global.GAPageview}
                               collectionMap = {collectionMap} />
                    ))}
                </Route>) : undefined
            }
        </Route>
    )
});

var routes = (
    <Route>
        <Route component={CollectionsTemplate}>
            <Route component={TopLevel.Collections} path='/office-furniture-los-angeles' onEnter={Global.GAPageview} />
            <Route>
                {collectionRoutes}
            </Route>
            <Route component={ProductDetail} path='/catalog/:itemID' onEnter={Global.GAPageview} />
            <Route component={ProductDetail} path='/catalog/*/:itemID(/tab/:tab)' onEnter={Global.GAPageview} />
            <Route component={ProductDetail} path='/catalog/*/*/:itemID(/tab/:tab)' onEnter={Global.GAPageview} />
        </Route>
        <Route path='/image/:imageID(/**)' component={Image} />  {/* Optional splat (/**) covers legacy /:imageID/:itemID URL structure */}
    </Route>
);

if (isNode) {
    global.routes = routes;
} else {
    var dom = (
        <Router history={Global.History}>
            {routes}
        </Router>
    );
    ReactDOM.render(dom, document.getElementById('collections'));
}



// WEBPACK FOOTER //
// ./src/collections/collections.jsx